import styled from 'styled-components';

import { BreadCrumb } from '@tillersystems/stardust';

export const StyledBreadCrumb = styled(BreadCrumb)`
  padding: ${({ theme: { dimensions } }) => dimensions.medium} 0;
  margin-top: -${({ theme: { dimensions } }) => dimensions.big};
  display: flex;
`;
